// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post } from "./api_client";
import { ApiStatus, IApiStatus } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function log(): ApiResult<string> {
	return post<string>(`/api/health/log`);
}

export async function getStatus(): ApiResult<ApiStatus> {
	return get<IApiStatus>(`/api/health/status`).then(result => result === undefined ? undefined :  new ApiStatus(result));
}

export async function enterMaintenanceMode(message?: string): ApiResult<ApiStatus> {
	return post<IApiStatus>(`/api/health/maintenancemode`, message).then(result => result === undefined ? undefined :  new ApiStatus(result));
}

export async function exitMaintenanceMode(message?: string): ApiResult<ApiStatus> {
	return post<IApiStatus>(`/api/health/maintenancemode/end`, message).then(result => result === undefined ? undefined :  new ApiStatus(result));
}
